<template>
    <c-dialog ref="dialog" height="330" width="450" @resolve="editHandle">
        <c-form ref="form" unit-width="100%">
            <c-form-item label="关联用户">
                <c-input name="user_realname" disabled></c-input>
            </c-form-item>
            <c-form-item label="手机号">
                <c-input name="phone" disabled></c-input>
            </c-form-item>
            <c-form-item label="真实姓名">
                <c-input name="name" disabled></c-input>
            </c-form-item>
            <c-form-item>
                <span class="paypwd-tip">确认后将打开通联支付密码设置页面，请在页面内完成短信验证并设置 6 位数字密码；设置成功后列表【支付密码】状态变为“已设置”。</span>
            </c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>

export default {
    name: 'allinpay_set_paypwd',
    data() {
        return {
            userId: 0
        }
    },

    methods: {
        /*********打开弹窗，初始化**********/
        open(data) {
            this.$refs.form.clear();
            if (!data) {
                return false;
            }
            this.$refs.form.set(data);
            this.userId = data.user_id;
            this.$refs.dialog.open({
                title: '设置支付密码'
            });
        },

        /*******确认后获取通联页面地址并跳转********/
        editHandle(stop, next) {
            stop();
            this.request({
                url: '/allinpay/member/set/paypwd',
                data: {
                    client_user_id: this.userId
                },
                success: data => {
                    next();
                    //通联设置支付密码为H5跳转式，页面内完成短信验证与密码设置
                    window.open(data);
                    this.$message({
                        message: '请在打开的页面中完成支付密码设置',
                        type: 'success'
                    });
                    this.$emit('resolve');
                },
                fail: (code, data, msg) => {
                    this.$confirm({
                        message: msg,
                        buttonName: '我知道了',
                        cancelButton: false,
                        resolve: () => {
                        }
                    })
                    return false;
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
.paypwd-tip {
    display: block;
    line-height: 20px;
    font-size: 12px;
    color: #999;
}
</style>
